import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import CustomButton, {
  DangerButton,
  OutlinedButton,
  SecondaryButton
} from '../../../components/CustomButton';
import { TableCell, TableRow } from '../../../components/table/CustomTable';
import { Tag } from '../../../components/table/Status';
import { capitalizeAndRemoveUnderscore } from "../../../helpers/stringHelper";
import CustomIcon from "../../../components/CustomIcon";

function FocusItem({ item, onFocusItemEditClicked, onDelete, previewModal, setPreviewModal, isActive = false, onDuplicateFocusItem, ...props }) {

  const editFocusItem = () => {
    onFocusItemEditClicked();
  };

  return (
    <TableRow {...props}>
      <TableCell
        className="font-medium">{item.title ? item.title : item.display_type === "PRODUCT_VIEW" ?
          `${item.items.map((item) =>
            item.title)}      
        ` : item.title === "" ? "--" : ""}</TableCell>
      <TableCell>{item.type}</TableCell>
      <TableCell>
        <Tag label={capitalizeAndRemoveUnderscore(item.display_type)} />
      </TableCell>
      <TableCell>
        <div className="flex justify-end space-x-4">
          <OutlinedButton onClick={() => setPreviewModal(item)} isIconButton={true}>
            <CustomIcon icon="visibility" />
          </OutlinedButton>

          <CustomButton onClick={editFocusItem} isIconButton={true}>
            <CustomIcon icon="edit" />
          </CustomButton>

          {!isActive &&
            <DangerButton onClick={() => onDelete(item)} isIconButton={true}>
            <CustomIcon icon="delete" />
          </DangerButton>}

          {!!onDuplicateFocusItem && (
          <SecondaryButton onClick={() => onDuplicateFocusItem(item)} isIconButton={true}>
            <CustomIcon icon="content_copy" />
          </SecondaryButton>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
}

export default FocusItem;
